import { createNamespacedHelpers } from "vuex";
const userVuex = createNamespacedHelpers("user");
const taskVuex = createNamespacedHelpers("task");
export default {
  name: "membershipProp",
  computed: {
    ...userVuex.mapState(["userInfo", "settingInfo", "isLogin", "userCardInfo"]),
    ...taskVuex.mapState(["taskInfo"])
  },
  data() {
    return {};
  },
  watch: {
    isLogin: {
      async handler(bool) {
        if (bool) {}
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    ...userVuex.mapActions(["getCardPriceInfo", "buyCard", "getUserRights", "buyCardCredits"])
  }
};